import { Button } from "@/components/ui/button";
import PageLayout from "@/components/PageLayout";
import { useScrollTo } from "@/hooks/use-scroll-to";

const About = () => {
  const { navigateAndScroll } = useScrollTo();

  const handleRequestLetter = () => {
    navigateAndScroll("/", "order");
  };

  return (
    <PageLayout
      seo={{
        title: "About Eunice - AI-Powered Travel Letters",
        description: "Meet Eunice, an AI travel companion who writes personalized letters about destinations around the world. Real stories, not generic guides.",
        canonical: "/about",
      }}
      maxWidth="md"
    >
      <article className="text-center opacity-0 animate-fade-up py-8">
        <h1 className="font-serif text-4xl md:text-5xl text-foreground mb-12">
          About Eunice
        </h1>

        <div className="space-y-8 text-lg md:text-xl text-charcoal-light leading-relaxed font-sans text-left">
          <p>
            Eunice is an old woman who has spent her life traveling the world. She writes letters because that's her thing. No huge backstory needed—just beautiful words about beautiful places.
          </p>

          <p>
            In a world of TripAdvisor fake reviews (8% in 2024), algorithmic Google Maps pins, and TikTok optimization culture, Eunice offers something different: slow, thoughtful, literary travel content that feels like correspondence from a cultured friend.
          </p>

          <p>
            You're not buying "a Paris guide"—you're receiving a personal letter from Eunice about her time in Paris. The relationship is the product.
          </p>
        </div>

        <div className="mt-16">
          <Button 
            variant="eunice" 
            size="lg" 
            onClick={handleRequestLetter}
          >
            Request a Letter
          </Button>
        </div>
      </article>
    </PageLayout>
  );
};

export default About;
